import moment from 'moment'
export interface AttendSetting36Agreement {
  companyCode: string;
  createUser: string;
  createDate: Date;
  updateUser: string;
  updateDate: Date;
  agreementsId: string;
  targetYear: number;
  applyStartMonth: Date;
  monthOverConditions: number;
  monthOverConditionsHour: number;
  monthlyOvertimeHourList: Array<number>;
  yearOvertimeHourList: Array<number>;
  averageOvertimeHour: number;
  monthlyOverAndHolidayTimeHour: number;
  monthlyOverConditionsCountList: Array<number>;
}

export default class AttendSetting36AgreementDomain {
  constructor(private rawData: AttendSetting36Agreement) {
    this.rawData.companyCode = sessionStorage.getItem('loginUser.companyCode') || "";
    this.rawData.createUser = sessionStorage.getItem('loginUser.staffCode') || "";
    this.rawData.updateUser = sessionStorage.getItem('loginUser.staffCode') || "";
    
    // do nothing
    if (!this.rawData.monthlyOvertimeHourList) {
      this.monthlyOvertimeHourList = [0]
    }
    
    if(!this.rawData.monthlyOvertimeHourList){
      this.rawData.monthlyOvertimeHourList = [0];          
    }
    if(!this.rawData.yearOvertimeHourList){
      this.rawData.yearOvertimeHourList = [0];          
    }
    if(!this.rawData.monthlyOverConditionsCountList){
      this.rawData.monthlyOverConditionsCountList = [0];          
    }
    if(!this.rawData.averageOvertimeHour){
      this.rawData.averageOvertimeHour = 0;          
    }
    if(!this.rawData.monthlyOverAndHolidayTimeHour){
      this.rawData.monthlyOverAndHolidayTimeHour = 0;          
    }
    if(!this.rawData.monthOverConditions){
      this.rawData.monthOverConditions = 0;          
    }
    if(!this.rawData.monthOverConditionsHour){
      this.rawData.monthOverConditionsHour = 0;          
    }
  }

  static generateInitial(): AttendSetting36AgreementDomain {
    return new AttendSetting36AgreementDomain({
      companyCode: '',
      createUser: '',
      createDate: new Date(),
      updateUser: '',
      updateDate: new Date(),
      agreementsId: '',
      targetYear: new Date().getFullYear(),
      applyStartMonth: new Date(),
      monthOverConditions: 0,
      monthOverConditionsHour: 0,
      monthlyOvertimeHourList: [0],
      yearOvertimeHourList: [0],
      averageOvertimeHour: 0,
      monthlyOverAndHolidayTimeHour: 0,
      monthlyOverConditionsCountList: [0],
    });
  }
  
  getPostData(): any {
    return {
      companyCode: this.rawData.companyCode,
      createUser: this.rawData.createUser,
      updateUser: this.rawData.updateUser,
      agreementsId: this.rawData.agreementsId,
      targetYear: this.rawData.targetYear,
      applyStartMonth: moment(this.rawData.applyStartMonth).format('YYYY/MM/DD'),
      monthOverConditions: this.rawData.monthOverConditionsHour * 60,
      monthOverConditionsHour: this.rawData.monthOverConditionsHour,
      monthlyOvertimeHourList: this.rawData.monthlyOvertimeHourList,
      yearOvertimeHourList: this.rawData.yearOvertimeHourList,
      averageOvertimeHour: this.rawData.averageOvertimeHour,
      averageOvertimeHourHour: this.rawData.averageOvertimeHour,
      monthlyOverAndHolidayTimeHour: this.rawData.monthlyOverAndHolidayTimeHour,
      monthlyOverConditionsCountList: this.rawData.monthlyOverConditionsCountList,
    };
  }

  get companyCode(): string {
    return this.rawData.companyCode;
  }
  set companyCode(companyCode: string) {
    this.rawData.companyCode = companyCode;
  }

  get createUser(): string {
    return this.rawData.createUser;
  }
  set createUser(createUser: string) {
    this.rawData.createUser = createUser;
  }

  get createDate(): Date {
    return this.rawData.createDate;
  }
  set createDate(createDate: Date) {
    this.rawData.createDate = createDate;
  }

  get updateUser(): string {
    return this.rawData.updateUser;
  }
  set updateUser(updateUser: string) {
    this.rawData.updateUser = updateUser;
  }

  get updateDate(): Date {
    return this.rawData.updateDate;
  }
  set updateDate(updateDate: Date) {
    this.rawData.updateDate = updateDate;
  }

  get agreementsId(): string {
    return this.rawData.agreementsId;
  }
  set agreementsId(agreementsId: string) {
    this.rawData.agreementsId = agreementsId;
  }

  get targetYear(): number {
    return this.rawData.targetYear;
  }
  set targetYear(targetYear: number) {
    this.rawData.targetYear = targetYear;
  }

  get applyStartMonth(): Date {
    return this.rawData.applyStartMonth;
  }
  set applyStartMonth(applyStartMonth: Date) {
    this.rawData.applyStartMonth = applyStartMonth;
  }

  get monthOverConditions(): number {
    return this.rawData.monthOverConditions;
  }
  set monthOverConditions(monthOverConditions: number) {
    this.rawData.monthOverConditions = monthOverConditions;
  }

  get monthOverConditionsHour(): number {
    return this.rawData.monthOverConditionsHour;
  }
  set monthOverConditionsHour(monthOverConditionsHour: number) {
    this.rawData.monthOverConditionsHour = monthOverConditionsHour;
  }

  get monthlyOvertimeHourList(): Array<number> {
    return this.rawData.monthlyOvertimeHourList;
  }
  set monthlyOvertimeHourList(monthlyOvertimeHourList: Array<number>) {
    this.rawData.monthlyOvertimeHourList = monthlyOvertimeHourList;
  }

  get yearOvertimeHourList(): Array<number> {
    return this.rawData.yearOvertimeHourList;
  }
  set yearOvertimeHourList(yearOvertimeHourList: Array<number>) {
    this.rawData.yearOvertimeHourList = yearOvertimeHourList;
  }

  get averageOvertimeHour(): number {
    return this.rawData.averageOvertimeHour;
  }
  set averageOvertimeHour(averageOvertimeHour: number) {
    this.rawData.averageOvertimeHour = averageOvertimeHour;
  }

  get monthlyOverAndHolidayTimeHour(): number {
    return this.rawData.monthlyOverAndHolidayTimeHour;
  }

  set monthlyOverAndHolidayTimeHour(monthlyOverAndHolidayTimeHour: number) {
    this.rawData.monthlyOverAndHolidayTimeHour = monthlyOverAndHolidayTimeHour;
  }

  get monthlyOverConditionsCountList(): Array<number> {
    return this.rawData.monthlyOverConditionsCountList;
  }

  set monthlyOverConditionsCountList(monthlyOverConditionsCountList: Array<number>) {
    this.rawData.monthlyOverConditionsCountList = monthlyOverConditionsCountList;
  }

}
